export const getRegionOptions = (regions = []) => {
    return regions.map((region) => ({
        label: region.name,
        value: region.code,
    }));
};
//# sourceMappingURL=getRegionOptions.js.map